// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3t_sB","left":"styles_left__1aJxQ"};